import React from 'react';
import { heroStats } from '../../mock';

const Stats = () => {
  return (
    <section className="relative -mt-2">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="rounded-3xl bg-brand-blue text-white shadow-xl grid grid-cols-2 divide-x divide-white/15 overflow-hidden">
          {heroStats.map((s, i) => (
            <div key={i} className="p-8 lg:p-10 text-center">
              <div className="font-heading font-bold text-3xl lg:text-4xl text-brand-mint">{s.value}</div>
              <div className="mt-2 text-sm lg:text-base text-white/80 font-body">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
